import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserStatus } from '@buck-e-icp/interfaces';
import { Store } from '@ngrx/store';
import { filter, first, map } from 'rxjs';

import { selectStateDone } from '../../shared/utils';
import { AuthActions, authFeature } from '../store';

export const loggedInGuard: CanActivateFn = () => {
    const router = inject(Router);

    return inject(Store)
        .select(authFeature.selectActiveProfile)
        .pipe(
            filter(selectStateDone),
            first(),
            map((activeProfileState) => {
                const activeProfile = activeProfileState.result;
                if (!activeProfile) {
                    return router.createUrlTree(['/auth/login']);
                }
                // A deactivated profile (its tenant was stopped) may never access the app, not even by navigating
                // to a route directly. Send the user back to the profile selection page.
                if (activeProfile.status !== UserStatus.ACTIVE) {
                    return router.createUrlTree(['/auth/select-profile']);
                }
                return true;
            }),
        );
};

export const loggedOutGuard: CanActivateFn = (route, routerState) => {
    const store = inject(Store);
    const url = routerState.url;
    return store.select(authFeature.selectActiveProfile).pipe(
        filter(selectStateDone),
        first(),
        map((state) => {
            // we need to be logged out but are logged in => do logout but no redirect
            if (state.result) {
                store.dispatch(AuthActions.logout({ redirectUri: url }));
                return true;
            }
            return true;
        }),
    );
};
